import { render } from "./audienceList.vue?vue&type=template&id=445b48dc&scoped=true"
import script from "./audienceList.vue?vue&type=script&lang=js"
export * from "./audienceList.vue?vue&type=script&lang=js"

import "./audienceList.vue?vue&type=style&index=0&id=445b48dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445b48dc"]])

export default __exports__